import { render, staticRenderFns } from "./IconCardDefault.vue?vue&type=template&id=ebf253fe&"
import script from "./IconCardDefault.vue?vue&type=script&lang=ts&"
export * from "./IconCardDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports